class ColorSwatchHandler {
  constructor() {
    this.options = {
      swatchSelector: '.color-swatch',
      productSelector: '.grid-product',
      mainImageSelector: '.grid-product__image-mask img',
      secondaryImageSelector: '.grid-product__secondary-image img'
    };
    document.addEventListener('click', this.handleClick.bind(this));
  }
  handleClick(e) {
    const swatch = e.target.closest(this.options.swatchSelector);
    if (!swatch) return;
    e.preventDefault();
    const variantImage = swatch.dataset.variantImage;
    if (!variantImage) return;
    const productCard = swatch.closest(this.options.productSelector);
    if (!productCard) return;
    this.updateImages(productCard, variantImage);
  }
  updateImages(productCard, variantImage) {
    console.log('helloooo');
    const mainImage = productCard.querySelector(this.options.mainImageSelector);
    const secondaryImage = productCard.querySelector(this.options.secondaryImageSelector);
    
    if (mainImage) {
      this.updateImageAttributes(mainImage, variantImage);
    }
    if (secondaryImage) {
      this.updateImageAttributes(secondaryImage, variantImage);
    }
  }
  updateImageAttributes(img, baseUrl) {
    img.removeAttribute('srcset');
    img.src = baseUrl;
    const sizes = [180, 360, 540, 720, 900, 1080];
    const srcset = sizes
      .map(size => `${baseUrl.split('?')[0]}?width=${size} ${size}w`)
      .join(', ');
    img.srcset = srcset;
  }
}
new ColorSwatchHandler();